function Cancel(props)
{
    return(
        <svg className={props.class?props.class:''} width="100%" height="100%" viewBox="0 0 17.828 17.828">
  <polygon points="2.828 17.828 8.914 11.742 15 17.828 17.828 15 11.742 8.914 17.828 2.828 15 0 8.914 6.086 2.828 0 0 2.828 6.085 8.914 0 15 2.828 17.828"/>
</svg>
    )
}

export default Cancel